import { render, staticRenderFns } from "./EditFlatRateOrder.vue?vue&type=template&id=72741dd0&lang=pug&"
import script from "./EditFlatRateOrder.vue?vue&type=script&lang=ts&"
export * from "./EditFlatRateOrder.vue?vue&type=script&lang=ts&"
import style0 from "./EditFlatRateOrder.vue?vue&type=style&index=0&id=72741dd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports